/* eslint-disable no-const-assign */

/* eslint-disable no-case-declarations */
import { fromJS, remove, merge } from 'immutable';

import * as types from '../constants';

const defaultState = fromJS({
  appStatus: true,
  appStatusCurrency: true,
  currency: '',
  autoConvert: true,
  checkoutStatus: true,
  OriginalPriceStatus: true,
  positionStatus: true,
  backgroundColor: '#FFF',
  textColor: '#000000',
  selectedBackgroundColor: '#F17013',
  selectedTextColor: '#000000',
  hoverBackgroundColor: '#e1e2e1',
  hoverTextColor: '#000000',
  messageColor: '#000000',
  messageText: 'All your orders will be paid in USD. ',
  messageBackgroundColor: '#FFF',
  priceBackgroundColor: '#FFF',
  priceColor: '#000000',
  position: 100,
  progressBarSetting: 100,
  currencyTheme: 'flags',
  moneyFormat: '',
  moneyWidthCurrencyFormat: '',
  listCurrencies: [],
  selectedCurrencies: [],
  currencies: [],
  currenciesTemporary: [],
  checkboxAllCurrencies: [],
  checkboxDesktopMobile: [],
  displayCurrencyCode: false,
  removeDecimals: false,
  roundDecimals: false,
  roundTo: 99,
  save: '',
  loadContent: false,
  checkCode: false,
  addCustomerCurrency: true,
  contactPosition: '',
  contactCheckout: '',
  name: '',
  email: '',
  contactSuccess: false,
  currencySearch: '',
  showDesktop: true,
  showMobile: true,
  bellingUrl: '',
  chargePosition: '',
  dataLog: [],
  countAll: 0,
  billingUrlPro: '',
  billingStatus: 'active',
  listRoundingRule: [],
  positionFloat: 'float',
  currencyRate: [],
  version: 1,
  flagSize: 25,
  currencyBeside: 'box',
  discountCharge: false,
  price: '',
  discountExpires: false,
  discountActive: false,
  isSaved: false, // Nếu trạng thái = true sẽ hiển thị form ask for review
  showPreview: 'desktop',
  shopDomain: '',
  cartPage: true,
  collectionPage: true,
  customLink: ``,
  homePage: true,
  productsPage: true,
  appExtension: false,
  newVersionAppEmbed: false,
  appStatusTranslate: true
});

function getIndex(value, arr, prop) {
  for (let i = 0; i < arr.size; i++) {
    if (arr.getIn([i, prop]) === value) {
      return i;
    }
  }
  return -1; // to handle the case where the value doesn't exist
}

function checkNull(arr) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] === null || arr[i] === '') {
      return i;
    }
  }
  return -1; // to handle the case where the value doesn't exist
}

function getValueAllCurrencies(arr) {
  let valueAll = [];
  for (let i = 0; i < arr.size; i++) {
    valueAll = merge(valueAll, [arr.getIn([i, 'value'])]);
  }
  return valueAll; // to handle the case where the value doesn't exist
}

export const getCart = state => state.currencyReducer;

const currencyReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.TURN_ON_OFF:
      return state.set(action.value, !state.get(action.value));
    case types.CHANGE_THEME_CURRENCY:
      return state.set('currencyTheme', action.value);
    case types.CHANGE_COLOR:
      return state.set(action.name, action.value);
    case types.CHANGE_POSITION:
      return state.set('position', action.value);
    case types.ADD_CURRENCIES:
      const currenciesArray = state.get('currenciesTemporary');
      let index = '';
      let currencies = fromJS([]);
      for (let i = 0; i < currenciesArray.size; i++) {
        index = getIndex(currenciesArray.get(i), state.get('listCurrencies'), 'value');
        currencies = merge(currencies, [state.getIn(['listCurrencies', index])]);
      }
      return state.set('selectedCurrencies', currencies).set('currencies', currenciesArray);

    case types.CURRENCIES_TEMPORARY:
      let currenciesNew = state.get('currencies');
      const showBilling = state.get('version') === 2 && state.get('billingStatus') !== 'active';
      if (showBilling) {
        currenciesNew = currenciesNew.filter((currenciesNew, index) => index < 5);
      }

      return state
        .set('currenciesTemporary', currenciesNew)
        .set('checkboxAllCurrencies', currenciesNew.size === 164 ? ['checked'] : []);
    case types.CHOOSE_CURRENCIES:
      let checkboxAllCurrencies;
      if (action.value.length === 164) {
        checkboxAllCurrencies = ['checked'];
      } else {
        checkboxAllCurrencies = [];
      }
      return state.set('currenciesTemporary', fromJS(action.value)).set('checkboxAllCurrencies', checkboxAllCurrencies);
    case types.CHANGE_MESSAGE:
      return state.set('messageText', action.value);

    case types.DELETE_ALL_CURRENCIES:
      return state
        .set('selectedCurrencies', fromJS([]))
        .set('currencies', fromJS([]))
        .set('checkboxAllCurrencies', [])
        .set('currenciesTemporary', fromJS([]));

    case types.DELETE_CURRENCIES:
      const i = state.get('selectedCurrencies').indexOf(action.value);
      const j = state.get('currencies').indexOf(action.value.get('value'));
      return state
        .set('selectedCurrencies', remove(state.get('selectedCurrencies'), i))
        .set('currencies', remove(state.get('currencies'), j))
        .set('checkboxAllCurrencies', []);
    case types.ARRAY_MOVE_CURRENCIES:
      return state
        .set('selectedCurrencies', fromJS(action.selectedCurrencies))
        .set('currencies', fromJS(action.currencies));

    case types.SET_SHOP_SETTINGS:
      let checkCode = state.get('checkCode');
      let currencyshop = state.get('currency');
      currencyshop = action.data.currency ? action.data.currency : 'USD';
      if (action.checkCode) {
        checkCode = !state.get('checkCode');
      }
      const listCurrency = fromJS(JSON.parse(action.data.all_currency));
      let selectedCurrencies = action.data.json_data ? JSON.parse(action.data.json_data) : [];
      const currencyShop = listCurrency.get(getIndex(currencyshop, listCurrency, 'value'));
      if (selectedCurrencies.length === 0 || checkNull(selectedCurrencies) >= 0) {
        selectedCurrencies = [currencyShop];
      }
      selectedCurrencies = fromJS(selectedCurrencies);
      const checkMoneyFormat = action.data.money_format.indexOf('<span class=money>');
      const checkMoneyWidthFormat = action.data.money_width_currency_format.indexOf('<span class=money>');
      let barSetting = 33;
      if (action.data.progress_bar_setting >= 66) {
        if (checkMoneyFormat !== -1 && checkMoneyWidthFormat !== -1) {
          barSetting = 100;
        } else {
          barSetting = 66;
        }
      }
      let message = action.data.message;
      let home = action.data.home_page;
      let link = action.data.custom_link;
      let product = action.data.products_page;
      let collection = action.data.collection_page;
      let cart = action.data.cart_page;
      if (action.data.version === 2 && action.data.status_charge === 'cancelled') {
        message = false;
        home = true;
        link = '';
        product = true;
        collection = true;
        cart = true;
      }
      if (action.data.status_charge === 'cancelled') {
        action.data.translate_status = false;
      }
      let currenciesTemporary = state.get('currenciesTemporary');
      const reports = JSON.parse(action.data.data_log);
      return state
        .set('listCurrencies', listCurrency)
        .set('appStatusTranslate', action.data.translate_status)
        .set('currenciesTemporary', currenciesTemporary)
        .set('selectedCurrencies', selectedCurrencies)
        .set('backgroundColor', action.data.background_color)
        .set('textColor', action.data.text_color)
        .set('selectedBackgroundColor', action.data.background_color_select)
        .set('selectedTextColor', action.data.text_color_select)
        .set('hoverBackgroundColor', action.data.background_color_hover)
        .set('hoverTextColor', action.data.text_color_hover)
        .set('displayCurrencyCode', action.data.display_currency)
        .set('removeDecimals', action.data.remove_decimals)
        .set('roundDecimals', action.data.round_decimals)
        .set('roundTo', action.data.round_to)
        .set('checkoutStatus', message)
        .set('position', action.data.position)
        .set('messageText', action.data.message_text)
        .set('messageColor', action.data.message_color)
        .set('messageBackgroundColor', action.data.message_background_color)
        .set('OriginalPriceStatus', action.data.price_original_show)
        .set('priceColor', action.data.price_color)
        .set('priceBackgroundColor', action.data.price_background_color)
        .set('autoConvert', action.data.auto_convert)
        .set('currency', currencyshop)
        .set('moneyFormat', action.data.money_format)
        .set('moneyWidthCurrencyFormat', action.data.money_width_currency_format)
        .set('currencyTheme', action.data.theme)
        .set('appStatusCurrency', action.data.currency_status)
        .set('appStatus', action.data.activated)
        .set('currencies', fromJS(getValueAllCurrencies(selectedCurrencies)))
        .set('loadContent', true)
        .set('positionStatus', action.data.show_currency_position)
        .set('progressBarSetting', barSetting)
        .set('checkCode', checkCode)
        .set('showDesktop', action.data.is_show_desktop)
        .set('showMobile', action.data.is_show_mobile)
        .set('cartPage', cart)
        .set('collectionPage', collection)
        .set('customLink', link)
        .set('homePage', home)
        .set('productsPage', product)
        .set('chargePosition', action.data.charge)
        .set('dataLog', fromJS(reports.data))
        .set('countAll', reports.count_all)
        .set('billingStatus', action.data.status_charge)
        .set('addCustomerCurrency', action.data.add_customer_currency)
        .set('version', action.data.version)
        .set('discountCharge', action.data.discount_charge)
        .set('price', action.data.price)
        .set('discountExpires', action.data.discount_expires)
        .set('discountActive', action.data.discount_active)
        .set('shopDomain', action.data.shop_domain)
        .set('flagSize', action.data.flags_size ? action.data.flags_size : 25)
        .set('currencyBeside', action.data.currency_beside ? action.data.currency_beside : 'box')
        .set('positionFloat', action.data.position_float ? action.data.position_float : 'float')
        .set(
          'listRoundingRule',
          fromJS(action.data.list_rounding_rule ? JSON.parse(action.data.list_rounding_rule) : [])
        )
        .set('newVersionAppEmbed', action.data.new_version_app_embed);

    case types.CHANGE_CURRENCY_SETTING_FIELD:
      return state.set(action.payload.field, action.payload.value);
    case types.SAVE_SETTINGS_CURRENCY:
      return state.set('save', 'loading');
    case types.SAVE_SETTINGS_RESPONSE:
      const progressBar = state.get('progressBarSetting') <= 33 ? 66 : state.get('progressBarSetting');
      if (action.data.success === true) {
        return state.set('save', 'success').set('progressBarSetting', progressBar);
      }
      return state.set('save', 'error');
    case types.CHECKBOX_ALL_CURRENCIES:
      const valueAllCurrencies = getValueAllCurrencies(state.get('listCurrencies'));
      if (action.value[0] === 'checked') {
        return state.set('currenciesTemporary', fromJS(valueAllCurrencies)).set('checkboxAllCurrencies', ['checked']);
      }
      return state.set('currenciesTemporary', fromJS([])).set('checkboxAllCurrencies', []);
    case types.CHANGE_CONTACT_POSITION:
      return state.set('contactPosition', action.value);
    case types.CHANGE_CONTACT_CHECKOUT:
      return state.set('contactCheckout', action.value);
    case types.CHANGE_ADD_CUSTOMER_CURRENCY:
      return state.set('addCustomerCurrency', !state.get('addCustomerCurrency'));
    case types.CHECKBOX_DESKTOP_MOBILE:
      const showDesktop = !state.get(action.value);
      const showMobile = !state.get(action.value);
      return state
        .set(action.value, !state.get(action.value))
        .set('showDesktop', showDesktop)
        .set('showMobile', showMobile);
    case types.CHANGE_DISPLAY_DEVICE:
      return state.set(action.payload, !state.get(action.payload));
    case types.CHANGE_DISPLAY_SETTINGS:
      return state.set(action.payload.field, action.payload.value);
    case types.CHANGE_SIZE_FLAGS:
      return state.set('flagSize', action.value);
    case types.SET_SHOP_INFO:
      // Thêm dữ liệu vào fredskchat
      if (action.data && action.data.myshopify_domain && action.data.myshopify_domain.includes('.myshopify.com')) {
        window.fcWidget.user.setProperties({
          firstName: action.data.name,
          shopOwner: action.data.shop_owner,
          email: action.data.email,
          phone: action.data.phone,
          shop: action.data.myshopify_domain
        });
        const style = document.createElement('style');
        style.innerHTML = '#fc_frame{display: unset!important;}';
        document.body.appendChild(style);
      }
      return state.set('name', action.data.name).set('email', action.data.email);
    case types.CHANGE_CURRENCY_SEARCH:
      return state.set('currencySearch', action.value);
    case types.UPGRADE_PACKAGE_PRO_RESPONSE:
      return state.set('billingUrlPro', action.data.confirmation_url);
    case types.ADD_ROUNDING_RULE:
      return state.set('listRoundingRule', state.get('listRoundingRule').push(fromJS(action.payload)));
    case types.EDIT_ROUNDING_RULE:
      return state
        .setIn(['listRoundingRule', action.payload.index, 'start'], action.payload.start)
        .setIn(['listRoundingRule', action.payload.index, 'end'], action.payload.end)
        .setIn(['listRoundingRule', action.payload.index, 'round'], action.payload.round);
    case types.DELETE_ROUNDING_RULE:
      return state.removeIn(['listRoundingRule', action.payload]);
    case types.UPDATE_IS_SAVED:
      return state.set('isSaved', action.value);
    case types.CHANGE_POSITION_FLOAT:
      return state.set('positionFloat', action.value);
    case types.GET_CURRENCY_RATE_RESPONSE:
      return state.set('currencyRate', fromJS(action.data));
    case types.CHANGE_CURRENCY_BESIDE:
      return state.set('currencyBeside', action.value);
    case types.PRICE_CONFIGURATION:
      return state.set(action.label, action.value);
    case types.CHANGE_PREVIEW:
      let position = state.get('position');
      if (
        (action.value === 'mobile' && position === 5) ||
        (action.value === 'mobile' && position === 4) ||
        (action.value === 'mobile' && position === 2) ||
        (action.value === 'mobile' && position === 7)
      ) {
        position = 6;
      }
      return state.set('showPreview', action.value).set('position', position);
    case types.CHANGE_SHOPIFY:
      return state.set('appExtension', !state.get('appExtension'));
    default:
      return state;
  }
};

export default currencyReducer;
